import React from 'react'
import Header from '../Home/Header'
import Feature from '../Home/Feature'
import Service from '../Home/Service'

const HomePage = () => {
  return (
    <>
        <Header/>
        <Feature/>
        <Service/>
    </>
  )
}

export default HomePage